<template>
    <div class="type-select-screen">
        <h2 class="title">
            Add Your Podcast
        </h2>

        <p class="description">
            Choose the option below that describes your podcasting needs.
        </p>

        <div class="type-select">
            <TypeSelectOption
                :type="ACTION.CREATE"
                icon="new-show-hosted"
                description="I'm starting a NEW podcast."
                button-label="Start a Podcast"
                :on-select="onSelect"
            />
            <TypeSelectOption
                :type="ACTION.IMPORT"
                icon="new-show-feed"
                description="I'm adding an EXISTING podcast."
                button-label="Find My Podcast"
                :on-select="onSelect"
            />
        </div>
    </div>
</template>
<script>

/**
 * Internal dependencies.
 */
import TypeSelectOption from './../TypeSelectOption';
import { ACTION } from './../config';

export default {
    components: {
        TypeSelectOption,
    },

    props: {
        onSelect: {
            required: true,
            type: Function,
        },
    },

    computed: {
        /**
         * Gets the show types.
         *
         * @returns {object} Show types.
         */
        ACTION() {
            return ACTION;
        },
    },
};
</script>
<style scoped lang="scss">
    @use './TypeSelectScreen.scss';
</style>
